import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import configureStore from './configureStore';
import Root from './containers/Root';
import { REAUTH_WINDOW_NAME, REAUTH_MESSAGE } from './utils/auth';

import './index.css';

const bootstrap = () => {
  // для firefox неправильно работает автоматический scroll, поэтому необходимо отключить попытку бразуера сохранять
  // положение scroll
  window.history.scrollRestoration = 'manual';

  configureStore().then((store) => {
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
      <BrowserRouter>
        <Root store={store} />
      </BrowserRouter>
    );

    /*
       Read the details thoroughly before enabling it
       registerServiceWorker();
       */
  });
};

// Если это попап переаутентификации (открыт из utils/auth.openReauthPopup) и после
// логина Keycloak мы вернулись на origin приложения — сообщаем опенеру и закрываемся,
// не поднимая всё приложение в попапе.
if (window.opener && window.name === REAUTH_WINDOW_NAME) {
  window.opener.postMessage(REAUTH_MESSAGE, window.location.origin);
  window.close();
} else {
  bootstrap();
}
